import { Serializable } from 'types/interfaces';

export interface OfertaRegistroAPI {
  id: number;
  solicitud_de_registro: string;
  estado: number;
  codigo_cliente_elecsum: string;
  generacion_assignada: number;
  ahorro_anual_total: number;
  ahorro_anual_real: number;
  precio_de_acceso: number;
  ahorro_anual_co2: number;
  arboles_plantados: number;
  potencia_nominal_assignada: number;
  modo_de_acceso: number;
  duracion_del_contrato: number;
  ahorro_mensual_promedio: number;
  precio_mensual_promedio: number;
  excedentes: number;
  percentaje_facturacion: number;
  coeficiente_reparto: number;
  pedir_iban?: boolean;
  importe_anual_sin_autoconsumo?: number;
  origen_de_datos?: string;
} // o donde tengas definida la interfaz

export default class OfertaRegistroModel implements Serializable<OfertaRegistroModel> {
  id: number;

  solicitud_de_registro: string;

  estado: number;

  codigo_cliente_elecsum: string;

  generacion_assignada: number;

  ahorro_anual_total: number;

  ahorro_anual_real: number;

  precio_de_acceso: number;

  ahorro_anual_co2: number;

  arboles_plantados: number;

  potencia_nominal_assignada: number;

  modo_de_acceso: number;

  duracion_del_contrato: number;

  ahorro_mensual_promedio: number;

  precio_mensual_promedio: number;

  excedentes: number;

  percentaje_facturacion: number;

  coeficiente_reparto: number;

  pedir_iban?: boolean;

  importe_anual_sin_autoconsumo?: number;

  origen_de_datos?: string;

  deserialize(input: OfertaRegistroAPI): OfertaRegistroModel {
    if (!input) return this;

    Object.assign(this, input);
    return this;
  }

  deserializeArray(input: OfertaRegistroAPI[]): OfertaRegistroModel[] {
    return input?.map((item) => new OfertaRegistroModel().deserialize(item)) || [];
  }

  serialize(): OfertaRegistroAPI {
    return {
      id: this.id,
      solicitud_de_registro: this.solicitud_de_registro,
      estado: this.estado,
      codigo_cliente_elecsum: this.codigo_cliente_elecsum,
      generacion_assignada: this.generacion_assignada,
      ahorro_anual_total: this.ahorro_anual_total,
      ahorro_anual_real: this.ahorro_anual_real,
      precio_de_acceso: this.precio_de_acceso,
      ahorro_anual_co2: this.ahorro_anual_co2,
      arboles_plantados: this.arboles_plantados,
      potencia_nominal_assignada: this.potencia_nominal_assignada,
      modo_de_acceso: this.modo_de_acceso,
      duracion_del_contrato: this.duracion_del_contrato,
      ahorro_mensual_promedio: this.ahorro_mensual_promedio,
      precio_mensual_promedio: this.precio_mensual_promedio,
      excedentes: this.excedentes,
      percentaje_facturacion: this.percentaje_facturacion,
      coeficiente_reparto: this.coeficiente_reparto,
      pedir_iban: this.pedir_iban,
      importe_anual_sin_autoconsumo: this.importe_anual_sin_autoconsumo,
      origen_de_datos: this.origen_de_datos,
    };
  }

  setAttr<T>(key: string, value: T): void {
    Object.assign(this, { [key]: value });
  }
}
